export const CardTargetMap = {
  // LinkedIn个人主页查DM相关
  LinkedIn_profile_DM_click_access: "LinkedIn_profile_DM_click_access", // LinkedIn个人主页查DM打开职位选择弹窗
  LinkedIn_profile_DM_click_findmore: "LinkedIn_profile_DM_click_findmore", // LinkedIn个人主页查DM点击【Find more】
  LinkedIn_profile_DM_click_close: "LinkedIn_profile_DM_click_close", // LinkedIn个人主页查DM关闭职位选择弹窗
  LinkedIn_profile_DM_click_startnow: "LinkedIn_profile_DM_click_startnow", // LinkedIn个人主页查DM点击【Start Now】开始查询
  LinkedIn_profile_DM_click_viewall: "LinkedIn_profile_DM_click_viewall", // LinkedIn个人主页查DM点击【View all】
  LinkedIn_profile_DM_show_upgrade: "LinkedIn_profile_DM_show_upgrade", // LinkedIn个人主页查DM展示Upgrade按钮
  LinkedIn_profile_DM_click_upgrade: "LinkedIn_profile_DM_click_upgrade", // LinkedIn个人主页查DM点击Upgrade按钮
  LinkedIn_profile_DM_click_career: "LinkedIn_profile_DM_click_career", // LinkedIn个人主页查DM选择职位

  // LinkedIn企业主页查DM相关
  LinkedIn_company_DM_click_access: "LinkedIn_company_DM_click_access", // LinkedIn企业主页查DM打开职位选择弹窗
  LinkedIn_company_DM_click_findmore: "LinkedIn_company_DM_click_findmore", // LinkedIn企业主页查DM点击【Find more】
  LinkedIn_company_DM_click_close: "LinkedIn_company_DM_click_close", // LinkedIn企业主页查DM关闭职位选择弹窗
  LinkedIn_company_DM_click_startnow: "LinkedIn_company_DM_click_startnow", // LinkedIn企业主页查DM点击【Start Now】开始查询
  LinkedIn_company_DM_click_viewall: "LinkedIn_company_DM_click_viewall", // LinkedIn企业主页查DM点击【View all】
  LinkedIn_company_DM_show_upgrade: "LinkedIn_company_DM_show_upgrade", // LinkedIn企业主页查DM展示Upgrade按钮
  LinkedIn_company_DM_click_upgrade: "LinkedIn_company_DM_click_upgrade", // LinkedIn企业主页查DM点击Upgrade按钮
  LinkedIn_company_DM_click_career: "LinkedIn_company_DM_click_career", // LinkedIn企业主页查DM选择职位
};
